import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { GetOrder, GetOrders, get_orders } from "../../actions/orders";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";

import { DownloadOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
import json2csv from "json2csv";

const Orders = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const orders = useSelector((state) => state?.orders?.all);

  const [dates, setDates] = useState({});
  const [ordersList, setOrdersList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    filter: "B",
  });
  const location = useLocation();

  useEffect(() => {
    // if (!orders?.data?.orders) {
    sync(true, {});
    // }
    // eslint-disable-next-line
  }, [page]);

  useEffect(() => {
    return () => {
      resetOrders();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (Array.isArray(orders?.data?.orders?.orders) && page === 1) {
      setOrdersList(orders?.data?.orders?.orders);
      setTotalRecords(orders?.data?.orders?.total_records);
    } else if (Array.isArray(orders?.data?.orders?.orders) && page > 1) {
      setOrdersList((market) => [...market, ...orders?.data?.orders?.orders]);
    }
    // eslint-disable-next-line
  }, [orders]);

  useEffect(() => {
    if (!ordersList?.length) {
      setPage(1);
    }
    // eslint-disable-next-line
  }, [ordersList]);

  const resetOrders = () => {
    setOrdersList([]);
    setTotalRecords(0);
    setPage(1);
    dispatch({
      type: GetOrders.RESET,
    });
  };

  const sync = (resetSearch, dates) => {
    let fils = location?.state?.filters ? location?.state?.filters : filters;
    if (resetSearch) {
      setFilters((f) => ({ ...f, search: "" }));
      fils.search = "";
    }
    if (location?.state?.filters) {
      setFilters(fils);
      history.replace("/orders");
    }
    if (dates.start_date && dates.end_date) {
      dispatch(
        get_orders({
          email: localStorage.getItem("email"),
          ...dates,
          ...fils,
          per_page: 30,
          page,
        })
      );
    } else {
      if (!dates.start_date && !dates.end_date) {
        dispatch(
          get_orders({
            email: localStorage.getItem("email"),
            ...fils,
            per_page: 30,
            page,
          })
        );
      }
    }
  };

  const columns = [
    {
      header: "Order Date",
      accessor: "date",
      width: 10,
      cell: (row) => (
        <span>
          {moment(row?.order_sales_nav?.QuotationDate, "YYYYMMDD").format(
            "MM/DD/YY"
          )}
        </span>
      ),
    },
    {
      header: "Temporary Order Number",
      accessor: "order_number",
      width: 12,
      cell: (row) => (
        <span
          className="error-text cursor"
          // onClick={(e) => {
          //   e.stopPropagation();
          //   history.push("/order-detail");
          // }}
        >
          {row.order_number}
        </span>
      ),
    },
    {
      header: "Order Type",
      accessor: "order_type",
      width: 12,
      cell: (row) => (
        <span style={{ textTransform: "uppercase" }}>{row.order_type}</span>
      ),
    },
    {
      header: "SO Number",
      accessor: "so_number",
      width: 12,
      cell: (row) => (
        <span className="error-text">
          {row.so_number ? row.so_number : "-"}
        </span>
      ),
    },
    {
      header: "PO Number",
      accessor: "po_number",
      width: 12,
      cell: (row) => (
        <span className="error-text">
          {row?.order_sales_nav?.Bstnk
            ? row?.order_sales_nav?.Bstnk
            : row.po_number}
        </span>
      ),
    },
    {
      header: "Ordered Quantity",
      accessor: "total_quantity",
      width: 8,
    },
    // {
    //   header: "20 Foot",
    //   accessor: "foot_20",
    //   width: 6,
    // },
    // {
    //   header: "40 foot",
    //   accessor: "foot_40",
    //   width: 6,
    // },
    {
      header: "Delivery Address",
      accessor: "delivery_address",
      width: 18,
      cell: (row) => (
        <span>
          {typeof row?.delivery_address === "string" ? (
            row?.delivery_address
          ) : row?.order_sales_nav?.Street ? (
            <>
              {row?.order_sales_nav?.Street}
              {row?.order_sales_nav?.Street && ", "}
              {row?.order_sales_nav?.City1}
              {row?.order_sales_nav?.City1 && ", "}
              {row?.order_sales_nav?.Country}
              {row?.order_sales_nav?.Country && ", "}
              {row?.order_sales_nav?.PostCode1}
            </>
          ) : (
            <>
              {row?.delivery_address?.address1}
              {row?.delivery_address?.address1 && ", "}
              {row?.delivery_address?.address2}
              {row?.delivery_address?.address2 && ", "}
              {row?.delivery_address?.city}
              {", "}
              {row?.delivery_address?.zip}
            </>
          )}
        </span>
      ),
    },
    // {
    //   header: "PI Status",
    //   accessor: "pi_status",
    //   width: 14,
    //   cell: (row) => <span className="text-btn">{row.pi_status}</span>,
    //   className: "pi_status",
    // },
    {
      header: "Order Status",
      accessor: "order_status",
      width: 12,
      cell: (row) => (
        <span className="success-text">
          {row?.cancelled_order ? "Cancelled" : row.order_status}
        </span>
      ),
    },
  ];

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={
            <span>
              {`All Orders ${
                ordersList?.length ? `(${ordersList?.length})` : ""
              }`}
            </span>
          }
          showGrid={false}
          searchPlaceholder={"Search by order id..."}
          namedFilters={[
            {
              label: "Awaiting Approval",
              action: () => {
                resetOrders();
                let obj = {
                  email: localStorage.getItem("email"),
                };
                if (dates.end_date && dates.start_date) {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...dates,
                      ...filters,
                      filter: "B",
                      page: 1,
                      per_page: 30,
                    })
                  );
                } else {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...filters,
                      filter: "B",
                      page: 1,
                      per_page: 30,
                    })
                  );
                }
                setFilters((f) => ({
                  ...f,
                  filter: "B",
                }));
              },
              isActive: filters.filter === "B",
            },
            {
              label: "Confirmed",
              action: () => {
                resetOrders();
                let obj = {
                  email: localStorage.getItem("email"),
                };
                if (dates.end_date && dates.start_date) {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...dates,
                      ...filters,
                      filter: "A",
                      page: 1,
                      per_page: 30,
                    })
                  );
                } else {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...filters,
                      filter: "A",
                      page: 1,
                      per_page: 30,
                    })
                  );
                }
                setFilters((f) => ({ ...f, filter: "A" }));
              },
              isActive: filters.filter === "A",
            },
            {
              label: "Completed",
              action: () => {
                resetOrders();
                let obj = {
                  email: localStorage.getItem("email"),
                };
                if (dates.end_date && dates.start_date) {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...dates,
                      ...filters,
                      filter: "C",
                      page: 1,
                      per_page: 30,
                    })
                  );
                } else {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...filters,
                      filter: "C",
                      page: 1,
                      per_page: 30,
                    })
                  );
                }
                setFilters((f) => ({ ...f, filter: "C" }));
              },
              isActive: filters.filter === "C",
            },
            {
              label: "Cancelled",
              action: () => {
                resetOrders();
                let obj = {
                  email: localStorage.getItem("email"),
                };
                if (dates.end_date && dates.start_date) {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...dates,
                      ...filters,
                      filter: "X",
                      page: 1,
                      per_page: 30,
                    })
                  );
                } else {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...filters,
                      filter: "X",
                      page: 1,
                      per_page: 30,
                    })
                  );
                }
                setFilters((f) => ({ ...f, filter: "X" }));
              },
              isActive: filters.filter === "X",
            },
            {
              label: `All`,
              action: () => {
                resetOrders();
                let obj = {
                  ...filters,
                  email: localStorage.getItem("email"),
                  filter: "",
                };
                if (dates.end_date && dates.start_date) {
                  dispatch(
                    get_orders({ ...obj, ...dates, page: 1, per_page: 30 })
                  );
                } else {
                  dispatch(get_orders({ ...obj, page: 1, per_page: 30 }));
                }
                setFilters((f) => ({ ...f, filter: "" }));
              },
              isActive: filters.filter === undefined,
            },
          ]}
          exportComponent={
            <button
              disabled={orders?.loading || !ordersList?.length}
              onClick={() => {
                let prods = ordersList?.map((ele) => ({
                  "Order date": moment(
                    ele?.order_sales_nav?.QuotationDate,
                    "YYYYMMDD"
                  ).format("MM/DD/YY"),
                  "Temporary Order Number": ele.order_number?.toString(),
                  "Order Type": ele.order_type,
                  "SO Number": ele.so_number,
                  "PO Number": ele?.order_sales_nav?.Bstnk
                    ? ele?.order_sales_nav?.Bstnk
                    : ele.po_number,
                  "Quantity Ordered": ele.total_quantity,
                  "Delivery Address": `${
                    typeof ele?.delivery_address === "string"
                      ? ele?.delivery_address
                      : `
                      ${
                        ele?.order_sales_nav?.Street
                          ? ele?.order_sales_nav?.Street + ", "
                          : ""
                      }
                      ${
                        ele?.order_sales_nav?.City1
                          ? ele?.order_sales_nav?.City1 + ", "
                          : ""
                      }
                      ${
                        ele?.order_sales_nav?.Country
                          ? ele?.order_sales_nav?.Country + ", "
                          : ""
                      }
                      ${
                        ele?.order_sales_nav?.PostCode1
                          ? ele?.order_sales_nav?.PostCode1
                          : ""
                      }
                    `
                  }`,
                  "Order Status": ele.order_status,
                }));
                let csv = json2csv.parse(prods);
                var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
                saveAs(blob, "OrdersHistory.csv");
              }}
            >
              <DownloadOutlined color="#333" />
            </button>
          }
          searchVal={filters.search}
          isDateFilter={true}
          isRange={true}
          isSync={true}
          sync={() => {
            resetOrders();
            sync(true, {});
            setDates({});
          }}
          onRangeChange={(val) => {
            let start_date = val?.[0] ? moment(val?.[0]) : null;
            let end_date = val?.[1] ? moment(val?.[1]) : null;
            if (val === null) {
              setDates({});
              sync(false, {});
            } else {
              if (start_date && end_date) {
                resetOrders();
                sync(false, {
                  start_date,
                  end_date,
                });
                setDates({
                  start_date,
                  end_date,
                });
              }
            }
          }}
          perPageLimit={10}
          callSearch={(search) => {
            resetOrders();
            let obj = {
              email: localStorage.getItem("email"),
            };

            if (dates.end_date && dates.start_date) {
              dispatch(
                get_orders({
                  ...obj,
                  ...dates,
                  ...filters,
                  search,
                  page: 1,
                  per_page: 30,
                })
              );
            } else {
              dispatch(
                get_orders({
                  ...obj,
                  ...filters,
                  search,
                  page: 1,
                  per_page: 30,
                })
              );
            }
            setFilters((f) => ({ ...f, search }));
          }}
        >
          <Table
            columns={columns}
            data={ordersList}
            action={false}
            actionWidth={8}
            loading={orders?.loading}
            totalRecords={totalRecords}
            lazy={true}
            isLastPage={
              ordersList?.length > 0 && ordersList?.length < totalRecords
            }
            onPagination={() => {
              setPage((p) => p + 1);
            }}
            onRowClick={(val) => {
              if (!val.order_number?.startsWith("21"))
                history.push("/order-detail", {
                  order_id: val.order_number,
                  order_number: val.order_number,
                  filters: filters,
                });
              else {
                dispatch({
                  type: GetOrder.SUCCESS,
                  payload: {
                    order: { ...val },
                  },
                });
                history.push("/order-detail", {
                  order: val,
                  order_number: val.order_number,
                  filters: filters,
                  isEportal: true,
                });
              }
            }}
          />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default Orders;
